// src/pages/SingleBlogPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../api/api";

export default function SingleBlogPage() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(`/blog/${slug}`);
        setBlog(res.data);
      } catch (err) {
        console.error(err);
        setError("Blog not found.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) return <div className="text-center mt-20">Loading...</div>;
  if (error) return <div className="text-center mt-20 text-red-500">{error}</div>;

  return (
    <div className="max-w-4xl mx-auto p-6">
      <Link to="/blogs" className="text-indigo-600 hover:underline mb-4 inline-block">
        ← Back to Blogs
      </Link>

      {blog.coverImage && (
        <img src={blog.coverImage} alt={blog.title} className="w-full h-64 object-cover rounded-lg mb-6" />
      )}
      <h1 className="text-3xl font-bold mb-4">{blog.title}</h1>
      {blog.tags && <p className="text-sm text-indigo-600 mb-2">{blog.tags}</p>}
      <p className="text-xs text-gray-400 mb-6">{new Date(blog.publishedAt).toLocaleDateString()}</p>
      <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: blog.content }} />
    </div>
  );
}
